<template>
  <div class="DetailedStepReport mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/ES003"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
        <el-main>
          <div class="mainWrao">
            <div class="recordTitle">
              <h1>{{$t('DetailedStepReport.StepStatisticsReport')}}</h1>
              <div class="machineSeach">
                <label style="margin-right:10px;font-size:12px;">{{$t('SingleTireStepAnalysis.labelTitle')}}</label>
                <!-- <el-cascader
                  class="idStyle"
                  @change="getShiftTime(machineID)"
                  :placeholder="$t('SingleTireStepAnalysis.placehoder1')"
                  expand-trigger="hover"
                  :options="options"
                  filterable
                  v-model="machineID">
                </el-cascader> -->
                <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
              </div>
            </div>
            <!-- 页面主体部分-->
            <div class="my">
              <div class="myLoading" v-loading="myLoading"></div>
              <div style="width:100%;height:66px;text-align:center;">
                <div class="myTitle" v-show="!$store.state.lang && machineName!==''">Equipment Step Statistics Report of {{machineName}}</div>
                <div class="myTitle" v-show="$store.state.lang && machineName!==''">{{machineName}}的设备步序统计报表</div>
              </div>
              <div class="myBody">
                <div class="myLeft">
                  <div>
                    <div :class="{'yearMonths':true,'yearMonths-right':!$store.state.lang}">
                      <div class="yearMonths-box">
                        <el-date-picker
                            v-model="monthValue"
                            type="month"
                            :placeholder="$t('AnalogValueAnalysis.Choosedate')"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                      </div>
                    </div>
                    <div class="nextMonth" v-show="nextMonthNone && $store.state.lang">下个月</div>
                    <div class="nextMonth" v-show="nextMonthNone && !$store.state.lang">Next Month</div>
                  </div>
                  <div>
                      <el-calendar v-model="monthValue">
                      </el-calendar>
                  </div>
                </div>
                <div class="myRight">
                  <div class="rightTitle">{{$t('DetailedStepReport.weeklyReport')}}</div>
                  <ul class="rightBody">
                      <li class="rightItem" v-for="(item,index) in fileName" :key="index">
                        <div class="rightLine"></div>
                        <div :class="{'rightCircular':true,'rightCircularColor':fileName[index].isBoolean === false}" @click="exportExcel(index,fileName[index].isBoolean)">
                          <downloadIcon  title="" class="downloadIcon"/>
                          <p v-show="!fileName[index].isBoolean" class="fileName">{{$t('DetailedStepReport.NoData')}}</p>
                          <p v-show="fileName[index].isBoolean" class="fileName">{{fileName[index].fileName}}</p>
                        </div>
                      </li>
                  </ul>
                </div>
              </div>  
            </div>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import downloadIcon from "vue-material-design-icons/BriefcaseDownload.vue"
import { setTimeout } from 'timers';
import equipment from "@/components/Equipment.vue"

let timer = new Date();
timer.setDate(1)

export default {
  name: 'ES003',
  components: {
    leftNav,
    downloadIcon,
    equipment
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      fullscreenLoading: false,
      //我的代码
      monthValue:timer,//element-ui的变量
      machineName:'',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      fileName:[{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false}],
      fileTime:'',
      nextMonthNone:true,
      dataTrue:1,
      oldMonthValue:'',
      myLoading:false
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
    machineID(){
      this.monthValue = timer//当选中的机器发生变化时，日历重置
      this.getDate(1)//当选中设备变化时，文件名也随之变化
    },
    monthValue(){
          this.noNextMonth()//控制月份不能大于当前月份
          //下个月禁用状态
          if(this.monthValue === null){
            this.nextMonthNone = true
            return
          }
          let year = new Date().getFullYear()//此刻的年份
          let mon = new Date().getMonth()+1//此刻的月份
          let nowYaer = this.monthValue.getFullYear()//选择的年份
          let nowMon = this.monthValue.getMonth()+1//选择的月份
          if(nowMon >= mon && nowYaer>= year){
              this.nextMonthNone = true
          }else{
              this.nextMonthNone = false
          }

      let values = this.oldMonthValue

      if(this.dataTrue === 1){//控制日期的变化和数据请求的次数一致
          this.dataTrue = 0
          this.getDate(1)
      }else{
        if(!this.machineID[1]){
            return
          }else{
            this.monthValue = values
            return
          }
      } 
        
    }
  },
  mounted() {
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true
      this.$parent.reload()
    }else{
      this.getManiceList()
    }
  },
  destroyed() {
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[0]=Number(this.$store.state.defaultFactoryId)
      this.machineID[1]=value
      this.monthValue = timer//当选中的机器发生变化时，日历重置
      this.getDate(1)//当选中设备变化时，文件名也随之变化
      this.getShiftTime(this.machineID)
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang,
          factoryId: _this.$store.state.factoryId
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(localStorage.getItem('isMarketAccount') === '1') {
            _this.$store.commit('marketAccount',res.data.options)
          }
          _this.options = res.data.options
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    //我的代码
    getShiftTime(x){//动态绑定EventCode
      this.tbmid = x[1]
      let a = x[0]
      let arra = this.options.filter((item)=>{
        return item.value == a
      })
      let childrenarr = arra[0].children
      let brrb = childrenarr.filter((item)=>{
        return item.value == x[1]
      })
      this.machineName = brrb[0].label
    },
    getfileName(){//获取文件名
      this.myLoading = true
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/fileNameEquipmentStepStatisticsReport',
        params:{
          language:_this.$store.state.lang,
          machineId:_this.machineID[1],
          date:_this.fileTime,
          index:6
        }
      }).then(function(res){
        _this.dataTrue = 1
        setTimeout(function(){
            _this.myLoading = false
        },200)
        
        if (res.data.success === 'true') {
          _this.fileName = res.data.msg
        } else {
          _this.$message.error(_this.$t('PF001.noData'));
        }
      })
    },
    getDate(i){
      if(!this.machineID[1]){//设备不能为空
        return
      }else{
        let dateNum = this.monthValue.getDate()

        let monthVal = this.monthValue
        
        if(monthVal === null){//如果时间为空，则恢复初始状态
          this.fileName = [{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false}]
          return
        }
        if(monthVal.getDate()!==1){
          let clickMonth = this.monthValue
          clickMonth.setDate(1)
          monthVal = clickMonth
        }
        let x = i-1
        let weekStart = monthVal.getDay()
        if(weekStart === 0){
          weekStart = 7
        }
        let y = monthVal.getFullYear()
        let m = monthVal.getMonth()+1
        let d = monthVal.getDate()-weekStart+1
            d = d+x*7
            
            if(d<1){
              if(m==2 || m==4 || m==6 || m==8 || m==9 || m==11 || m==1){
                d = d+31
              }else if(m==5 || m==7 || m==10 || m==12){
                d = d+30
              }else if(m==3){
                let Leap = ''+y/4
                if(Leap.length>3){
                  d = d+28
                }else{
                  d = d+29
                }
              }
              m = m-1
            }
            if(m<1){
              m = m+12
              y = y-1
            }
            if(m<10){
              m = '0'+m
            }
            if(d<10){
              d = '0'+d
            }
        this.fileTime = y +'-'+ m +'-'+ d +' 07:30:00'

        this.oldMonthValue = monthVal
        this.getfileName()
        let todayDate = this.monthValue
        todayDate.setDate(dateNum)
      }
    },
    noNextMonth(){
      if(this.monthValue > new Date()){
        this.monthValue = timer
      }
    },
    exportExcel(i,j){
      if(!this.machineID[1]){
        this.$message.error(this.$t('AnalogValueAnalysis.equipment'));
      }else{
        if(j === false){
          return
        }
        if(this.monthValue === null){
          return
        }
        let dateNum = this.monthValue.getDate()
        let monthVal = this.monthValue

        if(monthVal.getDate()!==1){
          let clickMonth = this.monthValue
          clickMonth.setDate(1)
          monthVal = clickMonth
        }
        let x = i

        let weekStart = monthVal.getDay()
        let y = monthVal.getFullYear()
        let m = monthVal.getMonth()+1
        if(weekStart === 0){
          weekStart = 7
        }
        let d = monthVal.getDate()-weekStart+1
            d = d+x*7

            if(d<1){
              if(m==2 || m==4 || m==6 || m==8 || m==9 || m==11 || m==1){
                d = d+31
              }else if(m==5 || m==7 || m==10 || m==12){
                d = d+30
              }else if(m==3){
                let Leap = ''+y/4
                if(Leap.length>3){
                  d = d+28
                }else{
                  d = d+29
                }
              }
              m = m-1
              if(m<1){
                m = 12
              }
            }

            let Leap = ''+y/4
            if(Leap.length>3){//闰年
              if(m==2){
                if(d>29){
                  m = m+1
                  d=d-29
                }
              }else if(m==4 || m==6 || m==9 || m==11){
                if(d>30){
                  m = m+1
                  d=d-30
                }
              }else{
                if(d>31){
                  m = m+1
                  d=d-31
                }
              }
            }else{
              if(m==2){
                if(d>28){
                  m = m+1
                  d=d-28
                }
              }else if(m==4 || m==6 || m==9 || m==11){
                if(d>30){
                  m = m+1
                  d=d-30
                }
              }else{
                if(d>31){
                  m = m+1
                  d=d-31
                }
              }
            }

            if(m<10){
              m = '0'+m
            }
            if(d<10){
              d = '0'+d
            }
        let dataTime = y +'-'+ m +'-'+ d +' 07:30:00'
        
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        let urlData = '?machineId=' + this.machineID[1] + '&date=' + dataTime + '&language='+ this.$store.state.lang + '&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime +'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
          
        window.open('/url/excelEquipmentStepStatisticsReport' + urlData, '_blank')

        let todayDate = this.monthValue
        todayDate.setDate(dateNum)

      }
    }
  }
}
</script>


<style scoped>
.DetailedStepReport{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
  display:flex;
  align-items: center;
}
/* 我的样式 */
.my{
  height: 780px;
  width: 90%;
  margin: 50px auto;
  background-color: #fff;
  position: relative;
  user-select: none;
  /* border: 1px solid red */
}
.myLoading{
  height: 780px;
  width: 100%;
  position: absolute;
}
.myTitle{
  padding: 18px 0;
  font-size: 20px;
	line-height: 150%;
}
.myBody{
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}

.my .myLeft{
  width: 82%;
  height: 100%;
  border:1px solid #efefef;
  position: relative;
}
.yearMonths{
  width: 118px;
  position: absolute;
  right: 230px;
  top:11px;
  height: 28px;
  border:1px solid #DCDFE6;
  border-radius: 3px;
  overflow: hidden;
}
.yearMonths-right{
  right: 310px;
}
.nextMonth{
  /* display: none; */
  position: absolute;
  top: 12px;
  right: 20px;
  z-index: 10;
  border:1px solid #DCDFE6;
  border-left: none;
  color: #C0C4CC;
  font-size: 12px;
  line-height: 12px;
  /* height: 26px; */
  /* width: 66px; */
  padding: 7px 15px;
  text-align: center;
  border-radius: 0 3px 3px 0;
  background-color: #F5F7FA;
  cursor:no-drop;/* 鼠标悬浮禁用 */
  user-select: none;
  font-family: "Arial";
}
.yearMonths .yearMonths-box{
  position: absolute;
  top: -6px;
  left:-1px;
}

.my .myRight{
  width: 16%;
  height: 100;
  background-color: rgba(236, 235, 235, 1);
}
.myRight .rightTitle{
  color: rgba(80, 80, 80, 1);
  font:bold 16px/54px 'Microsoft YaHei';
  text-align: center;
}
.myRight .rightBody{
  padding-top: 55px;
}
.rightItem{
  display: flex;
  padding: 18px 0;
}
.rightItem .rightLine{
  width: 53px;
  height: 1px;
  background-color: rgba(153, 153, 153, 1);
  margin: 24px 5px 25px 0;
}
.rightItem .rightCircular{
  width: 24px;
  height: 24px;
  padding: 10px 13px 16px;
  border-radius: 50%;
  background-color: rgba(15, 157, 88, 1);
  text-align: center;
  cursor: pointer;
  position: relative;
}
.rightItem .rightCircularColor{
  background-color: rgba(153, 153, 153, 1);
}
.rightItem .rightCircular .downloadIcon{
  color: #fff;
  font-size: 24px;
}
.rightCircular:hover .fileName{
  display: block;
}
.fileName{
  display: none;
  position: absolute;
  right: 30px;
  width: 240px;
  background-color: #fff;
  text-align: center;
  word-wrap:break-word;
  font-size: 12px;
	line-height: 180%;
  color: rgba(80, 80, 80, 1);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1785714285714286);
  user-select: none;

}

/* element-ui样式 */
.el-date-editor.el-input, .el-date-editor.el-input__inner{
  width: 120px;
}

</style>

